import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteApiData } from "../helpers/AxiosInstance";

interface IUsePatchHook {
  queryKey: string[];
  navigateURL?: string;
}

const useDeleteHook = (props: IUsePatchHook) => {
  const { queryKey, navigateURL } = props;
  const queryClient: any = useQueryClient();
  const navigate = useNavigate();

  const { isPending: isLoading, mutateAsync, isSuccess, data, isError } = useMutation({
    mutationFn: deleteApiData,
    onSuccess: (data:any) => {
      if (data.status === 200) {
        toast.success("Deleted successfully");
        if (navigateURL) {
          navigate(navigateURL);
        }
      } else {
        if (data?.data?.non_field_errors) {
          toast.error(data?.data?.non_field_errors[0])
        } else {
          toast.error(data?.data?.message ?? "Something went wrong")
        }
      }
    },
    onError: (error) => {
      toast.error("Some things went wrongs");
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey ?? null);
    },
  }

  );
  return {
    isLoading,
    mutateAsync,
    isSuccess,
    data,
    isError,
  };
};

export default useDeleteHook;